import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import EditIcon from '@mui/icons-material/Edit';
import { Toolbar } from '../../components/ui/toolbar/toolbar.component';
import CustomModal from '../../components/ui/modal/modal.component';
import ClientInvoiceSettingsForm from '../../components/invoices/clientInvoiceSettingsForm.component';
import { Action } from '../../types/toolbar';
import { useHasPermission } from '../../contexts/auth';

export const ClientInvoiceSettingsActions = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const [editOpened, setEditOpened] = useState(false);
  // Invoice defaults only shape the invoices that get created, so they are
  // edited under the same permission as the invoices themselves.
  const canChange = useHasPermission('invoice.change_invoice');

  const actions: Action[] = [
    {
      id: 'edit-invoice-defaults',
      icon: <EditIcon />,
      label: t('Edit invoice defaults'),
      onClick: () => setEditOpened(true),
      disabled: !canChange,
    },
  ];

  return (
    <>
      <Toolbar actions={actions} />
      <CustomModal
        opened={editOpened}
        setOpened={setEditOpened}
        title={t('Edit invoice defaults')}
        minWidth={480}
        content={
          <ClientInvoiceSettingsForm clientId={id ?? ''} onSuccess={() => setEditOpened(false)} />
        }
      />
    </>
  );
};
